import React from 'react';
import { OperationProgressPlaceholder } from '../../../../shared/ui/progress';
import type { QuickFillLoadProgress } from '../../lib/quickFillLoadProgress';
import { buildQuickFillLoadProgressModel } from '../../lib/quickFillOperationProgress';

export interface QuickFillLoadingPlaceholderProps {
  isInitializing: boolean;
  isBuilding: boolean;
  buildProgress: string;
  loadProgress?: QuickFillLoadProgress | null;
}

export const QuickFillLoadingPlaceholder: React.FC<QuickFillLoadingPlaceholderProps> = ({
  isInitializing,
  isBuilding,
  buildProgress,
  loadProgress,
}) => {
  const activeProgress: QuickFillLoadProgress | null = isBuilding
    ? {
        phase: 'building',
        message: buildProgress || 'Building Quick Fill rows',
        detail: 'Converting the Revit snapshot into editable rows',
        currentStep: 4,
        totalSteps: loadProgress?.totalSteps ?? 4,
        metrics: loadProgress?.metrics,
      }
    : loadProgress ?? null;

  const model = buildQuickFillLoadProgressModel(
    activeProgress ?? {
      phase: isInitializing ? 'requesting' : 'preparing',
      message: isInitializing ? 'Preparing Quick Fill data from Revit' : 'Loading Quick Fill',
      detail: isBuilding
        ? 'Building the editable table from the Revit snapshot'
        : 'Waiting for the Revit connector',
      currentStep: isInitializing ? 2 : 1,
      totalSteps: 4,
    }
  );

  return (
    <OperationProgressPlaceholder
      model={model}
      sx={{
        minHeight: { xs: 160, md: 220 },
        height: '100%',
      }}
    />
  );
};
